const db = {
  letters: [
    { key: "a" },
    { key: "b" },
    { key: "c" },
    { key: "d" },
    { key: "e" },
    { key: "f" },
    { key: "g" },
    { key: "h" },
    { key: "i" },
    { key: "j" },
    { key: "k" },
    { key: "l" },
    { key: "m" },
    { key: "n" },
    { key: "o" },
    { key: "p" },
    { key: "q" },
    { key: "r" },
    { key: "s" },
    { key: "t" },
    { key: "u" },
    { key: "v" },
    { key: "w" },
    { key: "x" },
    { key: "y" },
    { key: "z" },
  ],
  solutions: [
    { id: 1, word: "ninja" },
    { id: 2, word: "spade" },
    { id: 3, word: "pools" },
    { id: 4, word: "drive" },
    { id: 5, word: "relax" },
    { id: 6, word: "times" },
    { id: 7, word: "train" },
    { id: 8, word: "cores" },
    { id: 9, word: "pours" },
    { id: 10, word: "blame" },
    { id: 11, word: "banks" },
    { id: 12, word: "phone" },
    { id: 13, word: "bling" },
    { id: 14, word: "coins" },
    { id: 15, word: "hello" },
  ],
};

export default db;
